import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { downloadsActions } from '../reducer/downloadsSlice';
import * as api from 'api/worker/downloads';
import { GetActualFilePathParams, GetDownloadListParams } from 'types/worker/downloads';

export function* getDownloadListSaga(action: PayloadAction<GetDownloadListParams>) {
  const { data } = yield call(api.getDownloads, action.payload);
  if (data) {
    yield put(downloadsActions.getDownloadListSuccess(data));
  } else {
    yield put(downloadsActions.getDownloadListFailure(data));
  }
}

export function* getActualFilePathSaga(action: PayloadAction<GetActualFilePathParams>) {
  const { data } = yield call(api.getActualFilePath, action.payload);
  if (data) {
    yield put(downloadsActions.getActualFilePathSuccess(data));
  } else {
    yield put(downloadsActions.getActualFilePathFailure(data));
  }
}

export function* getSRestSaga(action: PayloadAction<GetActualFilePathParams>) {
  const { data } = yield call(api.getSRest, action.payload);
  const jsonObj = JSON.stringify(data.result, null, 2);
  const file = new Blob([jsonObj], { type: 'text/json' });
  const sRestFile = { file, fileName: `${action.payload.styleId}.json` };
  if (data) {
    yield put(
      downloadsActions.getSRestSuccess({
        ...data,
        sRestFile,
      }),
    );
  } else {
    yield put(downloadsActions.getSRestFailure(data));
  }
}

export default function* downloadsSaga() {
  yield all([
    takeLatest(downloadsActions.getDownloadList.type, getDownloadListSaga),
    takeLatest(downloadsActions.getActualFilePath.type, getActualFilePathSaga),
    takeLatest(downloadsActions.getSRest.type, getSRestSaga),
  ]);
}
